import React from 'react';
import './thread-view-loading.scss';

const ThreadViewLoading: React.FC = () => {
  return (
    <div className='thread-view-loading-container'>
      <div className='message-loading-container'>
        <div className='message-loading'></div>
        <div className='message-loading'></div>
      </div>
      <div className='input-loading'>
        <div className='input-placeholder'></div>
        <div className='actions-row-placeholder'>
          <div className='action-placeholder'></div>
          <div className='action-placeholder'></div>
          <div className='send-placeholder'>
            <div className='send-placeholder-inner'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThreadViewLoading;
